import formValidateMixin from "../mixins/form-validate";
import ModalMixin from "../mixins/modal";
import Axios from 'axios';
export default {
  name: "user-info-modal",
  props: ["title", "value", "user"],
  mixins: [formValidateMixin, ModalMixin],
  data: function data() {
    return {
      groups: [],
      data: {
        id: '',
        realname: '',
        mobile: '',
        email: null,
        max_point_num: 1,
        max_trial_days: 1,
        employer: '',
        job_title: '',
        remark: ''
      },
      rules: {
        realname: {
          type: "string",
          required: true
        },
        mobile: {
          type: "string",
          required: true,
          pattern: /^((13[0-9])|(14[5,7,9])|(15[^4])|166|(18[0-9])|(17[0,1,3,5,6,7,8]))\d{8}$/
        },
        email: {
          type: "email",
          required: true
        },
        employer: {
          type: "string"
        },
        job_title: {
          type: "string"
        },
        remark: {
          type: "string"
        }
      },
      loading: false
    };
  },
  methods: {
    onLoad: function onLoad() {
      var _this = this;
      if (this.user) {
        this.data.realname = this.user.realname;
        this.data.mobile = this.user.mobile;
        this.data.email = this.user.email;
        this.data.max_point_num = this.user.max_point_num;
        this.data.max_trial_days = this.user.max_trial_days;
        this.data.employer = this.user.employer;
        this.data.job_title = this.user.job_title;
        this.data.remark = this.user.remark;
      }
      setTimeout(function () {
        _this.validate();
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;
      var _this$data = this.data,
        realname = _this$data.realname,
        mobile = _this$data.mobile,
        email = _this$data.email,
        max_point_num = _this$data.max_point_num,
        max_trial_days = _this$data.max_trial_days,
        employer = _this$data.employer,
        job_title = _this$data.job_title,
        remark = _this$data.remark;

      // 万恶的表单校验之数字
      max_point_num = parseInt(max_point_num);
      max_trial_days = parseInt(max_trial_days);
      if (isNaN(max_point_num) || max_point_num < 0) {
        this.$Message.error('最大试用点数必须是不小于1的正整数!');
        return;
      }
      if (isNaN(max_trial_days) || max_trial_days < 0) {
        this.$Message.error('最大试用天数必须是不小于1的正整数!');
        return;
      }
      var data = {
        realname: realname.trim(),
        mobile: mobile,
        email: email.trim(),
        max_point_num: max_point_num,
        max_trial_days: max_trial_days,
        employer: employer.trim(),
        job_title: job_title.trim(),
        remark: remark.trim()
      };
      this.loading = true;
      return Axios.put("/pmv5/service/users/".concat(this.user.id, "/"), data).then(function (resp) {
        _this2.loading = false;
        var _resp$data = resp.data,
          code = _resp$data.code,
          data = _resp$data.data;
        if (code === 0) {
          _this2.$Message.success('修改成功！');
          _this2.$emit('onModalClose', true);
        }
      }, function (e) {
        _this2.loading = false;
        throw e;
      });
    },
    resetData: function resetData() {
      this.$refs.form.resetFields();
      this.loading = false;
    }
  }
};